import { z } from "zod";
import { ownerSchema } from "@/api/http/schemas/ownerSchemas";

export const fileSchema = z.object({
  id: z.number(),
  file_size: z.number(),
  file_type: z.string(),
  file_url: z.string().url(),
  mime_type: z.string(),
  original_name: z.string(),
  owner_id: z.number().nullable().optional(),
  personal_information: ownerSchema.optional(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export type ApiFile = z.infer<typeof fileSchema>;
